import { Card, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import type { IndividualCompetitionResult } from '../types/api.types';
import { formatMemberName } from '../utils/members';

interface IndividualResultTableProps {
  results: IndividualCompetitionResult[] | null | undefined;
}

export default function IndividualResultTable({ results }: IndividualResultTableProps) {
  if (results === undefined || results === null) {
    return null;
  }
  const resultRows = results.map((result) => (
    <tr key={result.memberID}>
      <td style={{ verticalAlign: 'middle' }}>{result.position != null ? result.position : 'na'}</td>
      <td style={{ verticalAlign: 'middle', padding: '1px' }}>
        <img src={`/assets/${result.memberID}.jpg`} height="45px" alt="" />
        <span> </span>
        <Link to={`/members/${result.memberID}`}>
          <span>{` ${formatMemberName(result)}`}</span>
        </Link>
      </td>
      <td style={{ verticalAlign: 'middle' }}>{result.points != null ? result.points : 'na'}</td>
    </tr>
  ));
  return (
    <Card>
      <Card.Header>Last Crazy English Tournament</Card.Header>
      <Card.Body>
        <Table>
          <thead>
            <tr>
              <th>Pos</th>
              <th>Player</th>
              <th>Score</th>
            </tr>
          </thead>
          <tbody>{resultRows}</tbody>
        </Table>
      </Card.Body>
    </Card>
  );
}
